import { api } from "@/lib/api";
import { createAppointmentCancellation } from "@/lib/appointment-cancellation";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const cancel = createAppointmentCancellation(api.appointments);

export async function cancelAppointment(id: uuid, reason?: string): Promise<AppointmentJoin> {
  return toAppointmentJoin(await cancel(id, { reason, actingOrganization: activeOrganization() }));
}
